/* ═══════════════════════════════════════════════════════════════════════════
   PICTURE PARTY — the page loader
   Jeff: "we lost a spinner that popped up as soon as you selected your variant.
   it used to have a middle of the screen loader as soon as you selected it, and
   that loader would continue on the designer page until the product is done
   loading in. now it hangs for a couple seconds and then switches to the
   designer where the loader is still going while the remainder of the page
   loads."

   So it has to cover BOTH sides of a navigation:
     1. the product page, from the instant a layout is chosen
     2. the /tools/customize page, until the designer has actually mounted

   ⚠ NOTHING TO CHANGE IN THE PICKER. pp-layoutpicker.js already fires
   `pp:navigating` on window immediately before it submits the create-project
   form, so this listens for that. The theme's own customize button is covered
   too, for products that have no picker.

   ⛔ THE OVERLAY IS BUILT FROM INLINE MARKUP, NOT FETCHED. A loader that waits
   on a request before it can appear is not a loader. No image, no library, no
   webfont: the SVG is in this file and it paints on the first frame.

   ⚠ AND IT CAN NEVER TRAP ANYONE. Every path that shows it also arms a
   deadline that hides it, so a designer that fails to signal, an app block
   that never mounts or a navigation the browser cancels all end with the page
   visible rather than behind a white screen. */
(function () {
  'use strict';

  var MARK = "<path d='M63.8413 161.61C62.2672 163.776 59.8964 165.229 57.2502 165.648C56.7238 165.731 56.1973 165.773 55.6709 165.773C53.5512 165.773 51.4713 165.106 49.7344 163.844L8.72803 134.05H8.66395V202.864H77.4772V142.841L63.8413 161.61Z'/><path d='M68.699 113.874C67.582 114.281 66.4113 114.483 65.2441 114.483C63.7842 114.483 62.3261 114.166 60.977 113.536C58.5491 112.405 56.6719 110.355 55.7558 107.838L38.9386 61.6333L0 115.226L55.6727 155.675L92.2769 105.291L68.699 113.874Z'/><path d='M99.6836 76.5698C94.2718 75.2207 90.978 69.7397 92.327 64.3279L104.127 17.0006L41.7077 39.7196L65.2439 104.384L124.597 82.7816L99.6836 76.5698Z'/><path d='M145.967 63.4136C142.235 59.2695 142.569 52.8828 146.715 49.1508L183.406 16.1157L118.775 0.00170898L102.128 66.7698L162.555 81.8361L145.967 63.4136Z'/><path d='M191.694 78.3881C190.918 72.8655 194.766 67.7585 200.29 66.981L249.181 60.1111L204.611 10.6104L153.472 56.6561L195.143 102.938L191.694 78.3881Z'/><path d='M220.505 113.313C222.18 109.551 225.868 107.319 229.737 107.319C231.109 107.319 232.504 107.599 233.838 108.193L278.356 128.015L269.838 67.4053L201.693 76.982L210.087 136.71L220.505 113.313Z'/><path d='M226.087 158.593C227.818 157.424 229.782 156.865 231.725 156.865C234.969 156.865 238.155 158.427 240.107 161.319L267.458 201.87L292.597 145.409L229.732 117.42L205.098 172.75L226.087 158.593Z'/><path d='M204.892 202.098C210.47 202.098 214.991 206.62 214.991 212.198V261.264L270.214 224.015L231.733 166.966L179.648 202.098H204.892Z'/><path d='M136.078 212.197L204.891 212.197L204.891 281.011H136.078V212.197Z'/><path d='M164.554 145.707C164.554 134.338 155.337 125.123 143.97 125.123C132.601 125.123 123.385 134.338 123.385 145.707C123.385 157.076 132.601 166.29 143.97 166.29C155.337 166.29 164.554 157.076 164.554 145.707Z'/>";
  var VIEWBOX = '0.0 -5.8 292.6 292.6';
  var el = null, deadline = 0;

  /* ⛔ ONE CEILING, AND IT IS SHORT. These were 30s for the navigation and 25s
     on the designer page, and the in-frame loader in mc/designer.js sat behind
     them at 45s. They STACK: the navigation overlay runs, the page changes, the
     designer-page overlay takes over, and the in-frame one keeps the same mark
     on screen after that. Worst case was 30 + 45 = 75 seconds of identical blue
     logo, and Pete reported about a minute of it on a personalize.
     Nothing behind this overlay is worth hiding for that long. Lifting it early
     shows a page that is visibly working -- the browser's own progress, or
     Mediaclip's loader in the frame -- which reads as slow. Ours is identical at
     second 3 and second 60, which reads as broken. Measured handover on a real
     load is 5.2s for a mug and under 3s for a book, so 12s is slack. */
  var CEILING = 12000;

  function node() {
    if (el) return el;
    el = document.getElementById('pp-loader');
    if (el) return el;
    el = document.createElement('div');
    el.id = 'pp-loader';
    /* role=status + aria-label, matching the portal's #pageLoader */
    el.setAttribute('role', 'status');
    el.setAttribute('aria-label', 'Loading');
    el.innerHTML = '<svg viewBox="' + VIEWBOX + '" aria-hidden="true">' + MARK + '</svg>';
    (document.body || document.documentElement).appendChild(el);
    return el;
  }

  function show(maxMs) {
    var n = node();
    /* ⛔ NOT requestAnimationFrame, and I reached for it first. rAF does not
       fire in a backgrounded tab, so the overlay built itself and then sat at
       opacity 0 -- and a loader that waits for a frame is the wrong shape of
       thing anyway. Reading offsetHeight forces the style to be computed NOW,
       which gives the transition its starting point synchronously: the class
       goes on in the same task as the click. */
    void n.offsetHeight;
    n.classList.add('is-on');
    clearTimeout(deadline);
    deadline = setTimeout(hide, maxMs || CEILING);
  }

  function hide() {
    clearTimeout(deadline);
    if (el) el.classList.remove('is-on');
  }

  window.PPLoader = { show: show, hide: hide };

  /* ── 1. leaving the product page ───────────────────────────────────────── */
  window.addEventListener('pp:navigating', function () { show(CEILING); });

  /* ⛔ REMOVED: a trigger on the theme's own Personalize button.
     Jeff: "clicking the personalize button brings up an indefinite pp
     spinner." I added that click on the ASSUMPTION it always navigates. It
     does not -- when the picker has not mounted, that button goes through
     Mediaclip's own in-page flow, so nothing navigates and a full-screen
     blocking overlay just sat there until its deadline.

     `pp:navigating` stays, and it is safe for the opposite reason: the picker
     fires it on the line before `form.submit()`, so a navigation is already
     committed when it arrives. Never show a blocking overlay on a click whose
     outcome is a guess. */

  /* ⚠ A cached back-navigation restores the old DOM with the overlay still on.
     Without this the customer would return to a white screen. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) hide(); });
  window.addEventListener('pagehide', hide);

  /* ── 2. arriving on the designer page ─────────────────────────────────── */
  if (/\/tools\/customize/.test(location.pathname)) {
    show(CEILING);        /* dead: see the note below */

    /* mc/designer.js posts this from inside the iframe once the editor's own
       chrome has mounted -- the only honest "ready", since the parent cannot
       see into a cross-origin frame. */
    /* ⛔ EVERYTHING IN THIS BRANCH IS DEAD AND I WROTE IT TWICE. This file is
       a THEME ASSET, and /tools/customize is a bare Shopify app-proxy page that
       loads no theme assets at all -- which is the entire reason the loader was
       moved in-frame into mc/designer.js. So neither the show() above nor any
       listener here has ever run on the designer page. I added a load-timing
       log here and it could never have fired; the log lives in designer.js
       instead, inside the frame, where the event actually happens.
       Kept as a comment rather than code so the next person does not add a
       third thing that cannot run. */

    /* Belt: if the frame never speaks, its load event plus a beat is still
       better than the deadline. */
    window.addEventListener('load', function () {
      setTimeout(function () {
        var f = document.querySelector('iframe[src*="designer.mediacliphub.com"]');
        if (!f) hide();                       /* no designer here at all */
      }, 1200);
    });
  }
})();
